import { useStylesStore, useCashbackStore, usePlayerStore } from '@/stores';
import { Router } from 'vue-router';
import { useToast } from 'primevue/usetoast';
import { useDocumentTitle } from '@/composables/useDocumentTitle';
import { isCrystalDomain } from '@/utils/variables';
import { computed, nextTick } from 'vue';

export default function routerGuard(router: Router): void {
    router.beforeEach(async (to, from, next) => {
        const toast = useToast();
        const stylesStore = useStylesStore();
        const cashbackStore = useCashbackStore();
        const playerStore = usePlayerStore();
        const { setTitle } = useDocumentTitle();
        const title = computed(() => stylesStore.titlePage);
        const isCashbackEnabled = computed(() => cashbackStore.cashbackSettings?.is_enabled);
        try {
            await nextTick();
            await playerStore.ensurePlayerLoaded();
            await cashbackStore.ensureCashbackSettingsLoaded();
        } catch (error) {
            console.error('Error loading cashback settings in router guard:', error);
        }

        //const siteStatusStore = useSiteStatusStore();
        //const playerStore = usePlayerStore();
        //const authStore = useAuthStore();
        const jwt = localStorage.getItem('jwt');
        //const isBlocked = computed(() => siteStatusStore.isBlocked);
        //const isMaintenance = computed(() => siteStatusStore.isMaintenance);
        //const isBlockedOrMaintenance = computed(() => isBlocked.value || isMaintenance.value);

        try {
            //if (jwt && !playerStore.player?.id && !isBlockedOrMaintenance.value) {
            //        await playerStore.awaitGetPlayer();
            //}
            if (to.meta.isNeedAuth) {
                // if (!playerStore.player?.id) {
                //     return next('/');
                // }
                if (!jwt) {
                    return next('/');
                }
            }
            if (to.meta.onlyNotAuth) {
                if (jwt) {
                    return next('/');
                }
            }
            if (to.path.includes('/cashback') && !isCashbackEnabled.value) {
                return next('/');
            }
            if (to.meta.isOnlyTMB && isCrystalDomain) {
                return next('/');
            }
            next();
        } catch (error) {
            console.error('Error during navigation guard:', error);
            toast.add({ severity: 'error', group: 'global', summary: 'errors.get_player', detail: error, life: 4000 });
            next('/');
        }
        // const pageName = to.name?.toString()?.toLowerCase() as string;
        localStorage.setItem('namePage', to.name?.toString()?.toLowerCase() as string);
        setTitle(title.value, to.name?.toString()?.toLowerCase() as string);
    });
}
